import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import AlertsView from "./AlertsView";
import Programming from "./Programming";
import Configuration from "./Configuration";
import MainAlerts from "./MainAlerts";

// prettier-ignore
const RoutesAlerts = () => {
    return (
        <>
            <Route path="alerts" element={<PrivateRoute role="tech"><MainAlerts /></PrivateRoute>} />
            <Route path="alerts/alerts" element={<PrivateRoute role="tech"><AlertsView /></PrivateRoute>} />
            <Route path="alerts/configuration" element={<PrivateRoute role="superuser"><Configuration /></PrivateRoute>} />
            <Route path="alerts/programming" element={<PrivateRoute role="superuser"><Programming /></PrivateRoute>} />
        </>
    )
}
export default RoutesAlerts;
